/* Options:
Date: 2026-04-16 16:19:40
Version: 6.110
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5001

//GlobalNamespace: 
MakePropertiesOptional: True
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
DefaultImports: immerable:immer
*/

import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export interface IDelete
{
}

export interface IUserGetSingle
{
    metadata?: { [index: string]: Object; };
}

export interface ILookupGetCollectionByFormDefinitionId extends IGet
{
    formDefinitionId?: number;
}

export interface IConfigurationGetSingleById extends IGet
{
    id?: number;
}

export interface IConfigurationGetCollection extends IGet
{
    skip?: number;
    take?: number;
}

export interface IConfigurationGetSingleByCode extends IGet
{
    code?: string;
}

export interface IDataGetSingleById extends IGet
{
    id?: number;
}

export interface IDataGetCollection extends IGet
{
    skip?: number;
    take?: number;
}

export class SourceDataVerificationMasterGroup implements ISourceDataVerificationMasterGroup
{
    [immerable] = true;
    public id?: number;
    public name?: string;
    public code?: string;
    public trialCode?: string;
    public trialId?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<SourceDataVerificationMasterGroup>) { (Object as any).assign(this, init); }
}

export interface IDataWithTrialGetCollectionByTrialId extends IDataGetCollection
{
    trialId?: number;
}

export interface IDataWithTrialGetCollectionByTrialCode extends IDataGetCollection
{
    trialCode?: string;
}

export interface IDataWithTrialGetSingleByIdAndTrialId extends IDataGetSingleById
{
    trialId?: number;
}

export interface IDataWithTrialGetSingleByCodeAndTrialCode
{
    code?: string;
    trialCode?: string;
}

export class SourceDataVerificationCoordinatingGroup implements ISourceDataVerificationCoordinatingGroup
{
    [immerable] = true;
    public id?: number;
    public name?: string;
    public code?: string;
    public masterGroupId?: number;
    public trialCode?: string;
    public trialId?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<SourceDataVerificationCoordinatingGroup>) { (Object as any).assign(this, init); }
}

export class SourceDataVerificationCountry implements ISourceDataVerificationCountry
{
    [immerable] = true;
    public id?: number;
    public name?: string;
    public code?: string;
    public trialCode?: string;
    public trialId?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<SourceDataVerificationCountry>) { (Object as any).assign(this, init); }
}

export class SourceDataVerificationInstitution implements ISourceDataVerificationInstitution
{
    [immerable] = true;
    public id?: number;
    public name?: string;
    public code?: string;
    public reference?: string;
    public enabled?: boolean;
    public activatedDate?: string;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public countryId?: number;
    public trialCode?: string;
    public trialId?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<SourceDataVerificationInstitution>) { (Object as any).assign(this, init); }
}

export class SourceDataVerificationPatient implements ISourceDataVerificationPatient
{
    [immerable] = true;
    public id?: number;
    public institutionId?: number;
    public institutionCode?: string;
    public studyNumber?: string;
    public treatmentArm?: string;
    public trialId?: number;
    public trialCode?: string;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<SourceDataVerificationPatient>) { (Object as any).assign(this, init); }
}

export interface IPatientGetSingleByStudyNumber
{
    studyNumber?: string;
}

export class SourceDataVerificationRequestContext
{
    [immerable] = true;
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public countryId?: number;
    public institutionId?: number;
    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;
    public fileId?: number;

    public constructor(init?: Partial<SourceDataVerificationRequestContext>) { (Object as any).assign(this, init); }
}

export enum SourceDataVerificationPermission
{
    Access = 1,
    ViewMasterGroup = 2,
    ViewCoordinatingGroup = 3,
    ViewCountry = 4,
    ViewInstitution = 5,
    ViewPatient = 6,
    ViewSourceDataVerification = 7,
    ViewSourceData = 8,
    ViewConfiguration = 9,
    EditConfiguration = 10,
    ViewSourceDataNote = 11,
    ViewSourceDataNoteInternal = 12,
    ViewAllPatients = 18,
}

export enum SourceDataPriority
{
    Low = 1,
    Normal = 2,
    High = 3,
    Critical = 4,
}

export enum EventStatus
{
    Started = 1,
    Complete = 2,
}

export enum NoteType
{
    ValidationFailed = 1,
    Annotation = 2,
    Query = 3,
    ReasonForChange = 4,
    Internal = 5,
    ProtocolDeviation = 6,
    ImportantProtocolDeviation = 7,
}

export enum NoteStatus
{
    New = 1,
    Updated = 2,
    ResolutionProposed = 3,
    Closed = 4,
    NotApplicable = 5,
}

export enum FormStatus
{
    Started = 1,
    Complete = 2,
}

export interface ISourceDataConfigurationFormFieldValue extends IDataModel
{
    sourceDataConfigurationFormFieldId?: number;
    formFieldValueMetadataId?: string;
    priority?: SourceDataPriority;
    linked?: boolean;
    name?: string;
    alertInformation?: string;
    alertWarning?: string;
    alertError?: string;
    alertSuccess?: string;
}

export interface ISourceDataConfigurationFormField extends IDataModel
{
    sourceDataConfigurationFormVersionId?: number;
    sourceDataConfigurationFormSectionId?: number;
    formFieldMetadataId?: string;
    enabled?: boolean;
    linked?: boolean;
    excludeBlank?: boolean;
    priority?: SourceDataPriority;
    allowSourceDataVerification?: boolean;
    allowReview?: boolean;
    allowVerify?: boolean;
    allowFindings?: boolean;
    name?: string;
    alertInformation?: string;
    alertWarning?: string;
    alertError?: string;
    alertSuccess?: string;
    showAudit?: boolean;
    showNotes?: boolean;
    noteTypes?: NoteType[];
    noteStatuses?: NoteStatus[];
    values?: { [index: string]: ISourceDataConfigurationFormFieldValue; };
}

export interface ISourceDataConfigurationFormSection extends IDataModel
{
    sourceDataConfigurationFormVersionId?: number;
    formSectionMetadataId?: string;
    enabled?: boolean;
    linked?: boolean;
    excludeBlank?: boolean;
    priority?: SourceDataPriority;
    name?: string;
    alertInformation?: string;
    alertWarning?: string;
    alertError?: string;
    alertSuccess?: string;
    latestRepeat?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    fields?: { [index: string]: ISourceDataConfigurationFormField; };
}

export interface ISourceDataConfigurationFormVersion extends IDataModel
{
    sourceDataConfigurationFormId?: number;
    formVersionMetadataId?: string;
    enabled?: boolean;
    linked?: boolean;
    excludeBlank?: boolean;
    name?: string;
    priority?: SourceDataPriority;
    alertInformation?: string;
    alertWarning?: string;
    alertError?: string;
    alertSuccess?: string;
    sections?: { [index: string]: ISourceDataConfigurationFormSection; };
    fields?: { [index: string]: ISourceDataConfigurationFormField; };
}

export interface ISourceDataConfigurationForm extends IDataModel
{
    sourceDataConfigurationId?: number;
    sourceDataConfigurationEventId?: number;
    formMetadataId?: string;
    priority?: SourceDataPriority;
    enabled?: boolean;
    linked?: boolean;
    excludeBlank?: boolean;
    name?: string;
    alertInformation?: string;
    alertWarning?: string;
    alertError?: string;
    alertSuccess?: string;
    statuses?: FormStatus[];
    showNotes?: boolean;
    noteTypes?: NoteType[];
    noteStatuses?: NoteStatus[];
    versions?: { [index: string]: ISourceDataConfigurationFormVersion; };
}

export interface ISourceDataConfigurationEvent extends IDataModel
{
    sourceDataConfigurationId?: number;
    eventMetadataId?: string;
    enabled?: boolean;
    linked?: boolean;
    excludeBlank?: boolean;
    priority?: SourceDataPriority;
    name?: string;
    alertInformation?: string;
    alertWarning?: string;
    alertError?: string;
    alertSuccess?: string;
    statuses?: EventStatus[];
    showNotes?: boolean;
    noteTypes?: NoteType[];
    noteStatuses?: NoteStatus[];
    latestRepeat?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    forms?: { [index: string]: ISourceDataConfigurationForm; };
}

export interface ISourceDataConfiguration extends IDataModel, IHasTrialId, IHasTrialCode
{
    name?: string;
    description?: string;
    isTrialConfiguration?: boolean;
    events?: { [index: string]: ISourceDataConfigurationEvent; };
    forms?: { [index: string]: ISourceDataConfigurationForm; };
}

export enum MonitoringVisitStatus
{
    New = 1,
    Creating = 2,
    Created = 3,
    Started = 4,
    Updating = 5,
    Complete = 6,
    Cancelled = 7,
    Incomplete = 8,
}

export interface ISourceData extends IDataModel, IHasTrialId, IHasTrialCode, IHasPatientId, IHasPatientStudyNumber
{
    monitoringVisitId?: number;
    sourceDataConfigurationId?: number;
    status?: MonitoringVisitStatus;
    priority?: SourceDataPriority;
    updatedDate?: string;
    updatedBy?: string;
    events?: { [index: string]: { [index:number]: ISourceDataEvent; }; };
}

export enum AllocationType
{
    Constant = 1,
    FirstXPatients = 2,
    RepeatingCycle = 3,
}

export interface IMonitoringVisitPatient extends IDataModel, IHasPatientId, IHasPatientStudyNumber
{
    monitoringVisitId?: number;
    included?: boolean;
    sourceDataConfigurationId?: number;
}

export interface IMonitoringVisitContributor extends IDataModel
{
    monitoringVisitId?: number;
    contributor?: string;
    contributorUsername?: string;
}

export interface IMonitoringVisit extends IDataModel, IHasTrialId, IHasTrialCode, IHasInstitutionId, IHasInstitutionCode
{
    description?: string;
    allocationType?: AllocationType;
    properties?: { [index: string]: Object; };
    sourceDataConfigurationIds?: number[];
    status?: MonitoringVisitStatus;
    startDate?: string;
    endDate?: string;
    patients?: IMonitoringVisitPatient[];
    contributors?: IMonitoringVisitContributor[];
}

export interface IMonitoringVisitSettings extends IDataModel, IHasTrialId, IHasTrialCode
{
    allocationType?: AllocationType;
    properties?: { [index: string]: Object; };
    sourceDataConfigurationIds?: number[];
}

export interface IMonitoringVisitSettingsPatient extends IDataModel, IHasPatientId, IHasPatientStudyNumber
{
    monitoringVisitSettingsInstitutionId?: number;
    included?: boolean;
    sourceDataConfigurationId?: number;
}

export interface IMonitoringVisitSettingsInstitution extends IMonitoringVisitSettings, IHasInstitutionId, IHasInstitutionCode
{
    patients?: IMonitoringVisitSettingsPatient[];
}

export class Trial implements ITrial
{
    [immerable] = true;
    public id?: number;
    public name?: string;
    public code?: string;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<Trial>) { (Object as any).assign(this, init); }
}

export enum SourceDataFindingStatus
{
    Pending = 1,
    Resolved = 2,
    NotApplicable = 3,
}

export enum SourceDataFindingType
{
    DataQuality = 1,
    InformedConsent = 2,
    ProtocolAndIchGcpRequirements = 3,
    SafetyReporting = 4,
    InvestigationalProductReview = 5,
    InstitutionResourcesAndSiteStaffTraining = 6,
    MaintenanceOfTheInvestigatorFile = 7,
}

export interface ISourceDataFinding extends IDataModel, IHasTrialId, IHasTrialCode, IHasInstitutionId, IHasInstitutionCode, IHasPatientId, IHasPatientStudyNumber
{
    monitoringVisitId?: number;
    eventMetadataId?: string;
    eventRepeat?: number;
    formMetadataId?: string;
    formVersionMetadataId?: string;
    formSectionMetadataId?: string;
    formSectionRepeat?: number;
    formFieldMetadataId?: string;
    sourceDataNoteId?: number;
    status?: SourceDataFindingStatus;
    type?: SourceDataFindingType;
    reference?: string;
    detail?: string;
    creator?: string;
    creatorUsername?: string;
    createdDate?: string;
    resolver?: string;
    resolverUsername?: string;
    resolvedMonitoringVisitId?: number;
    resolvedDate?: string;
    discussedWith?: string;
}

export class SentrySettings
{
    [immerable] = true;
    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    [immerable] = true;
    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    [immerable] = true;
    // @DataMember(Order=1)
    public errorCode?: string;

    // @DataMember(Order=2)
    public fieldName?: string;

    // @DataMember(Order=3)
    public message?: string;

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable] = true;
    // @DataMember(Order=1)
    public errorCode?: string;

    // @DataMember(Order=2)
    public message?: string;

    // @DataMember(Order=3)
    public stackTrace?: string;

    // @DataMember(Order=4)
    public errors?: ResponseError[];

    // @DataMember(Order=5)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    [immerable] = true;
    // @DataMember(Order=1)
    public key?: string;

    // @DataMember(Order=2)
    public keyType?: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface IFileUploadTemporary
{
    guid?: string;
    name?: string;
    extension?: string;
    fileSize?: number;
    contentType?: string;
    image?: boolean;
}

export class User implements IUserDto
{
    [immerable] = true;
    public userId?: string;
    public userName?: string;
    public displayName?: string;
    public sessionId?: string;

    public constructor(init?: Partial<User>) { (Object as any).assign(this, init); }
}

export class LookupItem
{
    [immerable] = true;
    public id?: number;
    public value?: string;
    public order?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    [immerable] = true;
    public propertyName?: string;
    public items?: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class FormMetadata
{
    [immerable] = true;
    public formDefinitionId?: number;
    public formDefinitionCode?: string;
    public name?: string;
    public propertyName?: string;
    public title?: string;
    public instructions?: string;

    public constructor(init?: Partial<FormMetadata>) { (Object as any).assign(this, init); }
}

export class FormType implements IFormType
{
    [immerable] = true;
    public id?: number;
    public code?: string;
    public name?: string;

    public constructor(init?: Partial<FormType>) { (Object as any).assign(this, init); }
}

export enum ValidationErrorType
{
    Warning = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5,
}

export class FormDefinitionPropertyErrorMessage implements IFormDefinitionPropertyErrorMessage
{
    [immerable] = true;
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Forms.Models.Configuration.FormDefinitionProperty)")
    public formDefinitionPropertyId?: number;

    public errorCode?: string;
    public message?: string;
    public detailedMessage?: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormDefinitionPropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormDefinitionProperty
{
    [immerable] = true;
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Forms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public propertyName?: string;
    public label?: string;
    public detailedLabel?: string;
    public errorMessages?: FormDefinitionPropertyErrorMessage[];

    public constructor(init?: Partial<FormDefinitionProperty>) { (Object as any).assign(this, init); }
}

export class FormDefinition
{
    [immerable] = true;
    public id?: number;
    public code?: string;
    public type?: number;
    public name?: string;
    public instructions?: string;
    public patientInstructions?: string;
    public properties?: FormDefinitionProperty[];
    // @Ignore()
    public subformProperties?: { [index: string]: FormDefinitionProperty[]; };

    public constructor(init?: Partial<FormDefinition>) { (Object as any).assign(this, init); }
}

export enum ValidationResultType
{
    Valid = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5,
}

export class ValidationError implements IValidationError
{
    [immerable] = true;
    public property?: string;
    public message?: string;
    public detailedMessage?: string;
    public code?: string;
    public ruleSet?: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<ValidationError>) { (Object as any).assign(this, init); }
}

export class ValidationResult
{
    [immerable] = true;
    public result?: ValidationResultType;
    public errors?: ValidationError[];
    public metadata?: { [index: string]: Object; };

    public constructor(init?: Partial<ValidationResult>) { (Object as any).assign(this, init); }
}

export interface IEventFormMetadata extends IMetadata
{
    eventMetadataId?: string;
    formMetadataId?: string;
    order?: number;
}

export interface IEventMetadata extends IMetadata
{
    name?: string;
    order?: number;
    repeating?: boolean;
    forms?: IEventFormMetadata[];
}

export interface IFormSectionMetadata extends IMetadata
{
    formVersionMetadataId?: string;
    name?: string;
    repeating?: boolean;
}

export enum DataType
{
    String = 1,
    Integer = 2,
    Decimal = 3,
    Boolean = 4,
    Date = 5,
}

export enum FieldType
{
    Text = 1,
    Radio = 2,
    Checkbox = 3,
    File = 4,
    Numeric = 5,
    Select = 6,
    MultiSelect = 7,
    MultilineText = 8,
    Date = 9,
    Ctcae = 10,
}

export interface IFormFieldValueMetadata extends IMetadata
{
    formFieldMetadataId?: string;
    name?: string;
    order?: number;
}

export interface IFormFieldMetadata extends IMetadata
{
    formVersionMetadataId?: string;
    formSectionMetadataId?: string;
    parentFormFieldMetadataId?: string;
    name?: string;
    data?: { [index: string]: string; };
    order?: number;
    dataType?: DataType;
    fieldType?: FieldType;
    values?: IFormFieldValueMetadata[];
}

export interface IFormVersionMetadata extends IMetadata
{
    formMetadataId?: string;
    name?: string;
    order?: number;
    sections?: IFormSectionMetadata[];
    fields?: IFormFieldMetadata[];
}

export interface IFormMetadata extends IMetadata
{
    name?: string;
    versions?: IFormVersionMetadata[];
}

export interface ITrialFormMetadata
{
    trialId?: number;
    trialCode?: string;
    events?: IEventMetadata[];
    forms?: IFormMetadata[];
}

export interface ISourceDataSubnote extends IDataModel
{
    sourceDataNoteId?: number;
    referenceId?: number;
    title?: string;
    note?: string;
    status?: NoteStatus;
    creator?: string;
    creatorUsername?: string;
    createdDate?: string;
}

export interface ISourceDataNote extends IDataModel, IHasPatientId, IHasPatientStudyNumber, IHasInstitutionCode, IHasInstitutionId, IHasTrialCode, IHasTrialId
{
    eventMetadataId?: string;
    eventRepeat?: number;
    formMetadataId?: string;
    formVersionMetadataId?: string;
    formSectionMetadataId?: string;
    formSectionRepeat?: number;
    formFieldMetadataId?: string;
    referenceId?: number;
    sourceDataEventId?: number;
    sourceDataFormId?: number;
    sourceDataFieldId?: number;
    type?: NoteType;
    status?: NoteStatus;
    creator?: string;
    creatorUsername?: string;
    createdDate?: string;
    notes?: ISourceDataSubnote[];
}

export interface ISourceDataSummary extends IDataModel, IHasTrialId, IHasTrialCode, IHasPatientId, IHasPatientStudyNumber
{
    monitoringVisitId?: number;
    sourceDataConfigurationId?: number;
    status?: MonitoringVisitStatus;
    priority?: SourceDataPriority;
}

export interface ISourceDataConfigurationSummary extends IDataModel, IHasTrialId, IHasTrialCode
{
    isTrialConfiguration?: boolean;
    name?: string;
    description?: string;
}

export interface IMonitoringVisitSummary extends IDataModel, IHasTrialId, IHasTrialCode, IHasInstitutionId, IHasInstitutionCode
{
    description?: string;
    allocationType?: AllocationType;
    properties?: { [index: string]: Object; };
    sourceDataConfigurationIds?: number[];
    status?: MonitoringVisitStatus;
    startDate?: string;
    endDate?: string;
}

export interface IValidationError
{
    property?: string;
    message?: string;
    detailedMessage?: string;
    code?: string;
    type?: ValidationErrorType;
}

export interface IValidationResult
{
    metadata?: { [index: string]: Object; };
    result?: ValidationResultType;
    errors?: IValidationError[];
}

export interface ISourceDataVerificationMasterGroup extends IMasterGroup, IHasTrialCode, IHasTrialId
{
}

export interface IMasterGroup extends IDataModel, IHasCode
{
    name?: string;
}

export interface IDataModel extends IModel, IHasAudit
{
}

export interface IModel
{
    id?: number;
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy?: string;
    modifiedDate?: string;
    modifiedBy?: string;
}

export interface IHasCode
{
    code?: string;
}

export interface IHasTrialCode
{
    trialCode?: string;
}

export interface IHasTrialId
{
    trialId?: number;
}

export interface ISourceDataVerificationCoordinatingGroup extends ICoordinatingGroup, IHasTrialCode, IHasTrialId
{
}

export interface ICoordinatingGroup extends IDataModel, IHasMasterGroupId, IHasCode
{
    name?: string;
}

export interface IHasMasterGroupId
{
    masterGroupId?: number;
}

export interface ISourceDataVerificationCountry extends ICountry, IHasTrialCode, IHasTrialId
{
}

export interface ICountry extends IDataModel, IHasCode
{
    name?: string;
}

export interface ISourceDataVerificationInstitution extends IInstitution, IHasTrialCode, IHasTrialId
{
    reference?: string;
}

export interface IInstitution extends IDataModel, IHasMasterGroupId, IHasCoordinatingGroupId, IHasCountryId, IHasCode
{
    name?: string;
    enabled?: boolean;
    activatedDate?: string;
}

export interface IHasCoordinatingGroupId
{
    coordinatingGroupId?: number;
}

export interface IHasCountryId
{
    countryId?: number;
}

export interface ISourceDataVerificationPatient extends IPatient, IHasTrialCode, IHasTrialId
{
    treatmentArm?: string;
    institutionCode?: string;
}

export interface IPatient extends IDataModel, IHasInstitutionId
{
    studyNumber?: string;
}

export interface IHasInstitutionId
{
    institutionId?: number;
}

export interface IHasPatientId
{
    patientId?: number;
}

export interface IHasPatientStudyNumber
{
    patientStudyNumber?: string;
}

export interface IHasInstitutionCode
{
    institutionCode?: string;
}

export interface ITrial extends IDataModel, IHasCode
{
    name?: string;
}

export interface IUserDto
{
    userId?: string;
    userName?: string;
    displayName?: string;
    sessionId?: string;
}

export interface ILookupItem
{
    id?: Object;
    value?: Object;
    order?: Object;
}

export interface ILookup
{
    propertyName?: string;
    items?: ILookupItem[];
}

export interface IFormType extends IConfigurationModel, IHasCode
{
    name?: string;
}

export interface IConfigurationModel extends IModel
{
}

export interface IFormDefinitionPropertyErrorMessage extends IConfigurationModel, IHasFormDefinitionPropertyId
{
    errorCode?: string;
    message?: string;
    detailedMessage?: string;
    type?: ValidationErrorType;
}

export interface IFormDefinitionProperty extends IConfigurationModel, IHasFormDefinitionId
{
    propertyName?: string;
    label?: string;
    detailedLabel?: string;
    errorMessages?: IFormDefinitionPropertyErrorMessage[];
}

export interface IFormDefinition extends IConfigurationModel, IHasCode
{
    type?: number;
    name?: string;
    instructions?: string;
    properties?: IFormDefinitionProperty[];
    subformProperties?: { [index: string]: IFormDefinitionProperty[]; };
}

export interface ISourceDataForm extends IDataModel
{
    sourceDataEventId?: number;
    formMetadataId?: string;
    formVersionMetadataId?: string;
    status?: FormStatus;
    priority?: SourceDataPriority;
    startDate?: string;
    updateDate?: string;
    completeDate?: string;
    fields?: { [index: string]: { [index:number]: ISourceDataField; }; };
    notes?: ISourceDataNote[];
}

export interface ISourceDataEvent extends IDataModel
{
    sourceDataId?: number;
    eventMetadataId?: string;
    repeat?: number;
    status?: EventStatus;
    startDate?: string;
    priority?: SourceDataPriority;
    forms?: { [index: string]: ISourceDataForm; };
    notes?: ISourceDataNote[];
}

export interface IHasFormDefinitionId
{
    formDefinitionId?: number;
}

export interface IMetadata
{
    id?: string;
}

export interface IHasFormDefinitionPropertyId
{
    formDefinitionPropertyId?: number;
}

export enum FieldAuditType
{
    Inserted = 1,
    Updated = 2,
    Deleted = 3,
}

export interface ISourceDataFieldAudit extends IDataModel
{
    sourceDataFieldId?: number;
    referenceId?: number;
    oldValue?: string;
    newValue?: string;
    editor?: string;
    editorUsername?: string;
    auditDate?: string;
    auditType?: FieldAuditType;
}

export interface ISourceDataField extends IDataModel
{
    sourceDataFormId?: number;
    formSectionMetadataId?: string;
    formFieldMetadataId?: string;
    repeat?: number;
    priority?: SourceDataPriority;
    reviewed?: boolean;
    reviewedBy?: string;
    verified?: boolean;
    verifiedBy?: string;
    value?: string;
    notes?: ISourceDataNote[];
    audit?: ISourceDataFieldAudit[];
}

export class GetClientAppSettingsResponse
{
    [immerable] = true;
    public settings?: ClientAppSettings;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class HelloResponse
{
    [immerable] = true;
    public result?: string;

    public constructor(init?: Partial<HelloResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userId?: string;

    // @DataMember(Order=2)
    public sessionId?: string;

    // @DataMember(Order=3)
    public userName?: string;

    // @DataMember(Order=4)
    public displayName?: string;

    // @DataMember(Order=5)
    public referrerUrl?: string;

    // @DataMember(Order=6)
    public bearerToken?: string;

    // @DataMember(Order=7)
    public refreshToken?: string;

    // @DataMember(Order=8)
    public profileUrl?: string;

    // @DataMember(Order=9)
    public roles?: string[];

    // @DataMember(Order=10)
    public permissions?: string[];

    // @DataMember(Order=11)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=12)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public allRoles?: string[];

    // @DataMember(Order=2)
    public allPermissions?: string[];

    // @DataMember(Order=3)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public allRoles?: string[];

    // @DataMember(Order=2)
    public allPermissions?: string[];

    // @DataMember(Order=3)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public results?: UserApiKey[];

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public results?: UserApiKey[];

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

export class UploadResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public upload?: IFileUploadTemporary;

    public constructor(init?: Partial<UploadResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved user. */
    // @DataMember(Order=2)
    public user?: User;

    public constructor(init?: Partial<UserSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved lookups. */
    // @DataMember(Order=2)
    public lookups?: Lookup[];

    public constructor(init?: Partial<LookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormMetadataResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public formMetadata?: FormMetadata[];

    public constructor(init?: Partial<GetFormMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormTypeSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form type. */
    // @DataMember(Order=2)
    public configuration?: FormType;

    public constructor(init?: Partial<FormTypeSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormTypeCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form types. */
    // @DataMember(Order=2)
    public configuration?: FormType[];

    public constructor(init?: Partial<FormTypeCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form definition. */
    // @DataMember(Order=2)
    public configuration?: FormDefinition;

    public constructor(init?: Partial<FormDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form definitions. */
    // @DataMember(Order=2)
    public configuration?: FormDefinition[];

    public constructor(init?: Partial<FormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved master group. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationMasterGroup;

    public constructor(init?: Partial<MasterGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved master groups. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationMasterGroup[];

    public constructor(init?: Partial<MasterGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<MasterGroupValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CoordinatingGroupSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved coordinating group. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCoordinatingGroup;

    public constructor(init?: Partial<CoordinatingGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CoordinatingGroupCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved coordinating groups. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCoordinatingGroup[];

    public constructor(init?: Partial<CoordinatingGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CoordinatingGroupValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<CoordinatingGroupValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountrySingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved country. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCountry;

    public constructor(init?: Partial<CountrySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountryCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved countrys. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCountry[];

    public constructor(init?: Partial<CountryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountryValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<CountryValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved institution. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationInstitution;

    public constructor(init?: Partial<InstitutionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved institutions. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationInstitution[];

    public constructor(init?: Partial<InstitutionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<InstitutionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved patient. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationPatient;

    public constructor(init?: Partial<PatientSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved patients. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationPatient[];

    public constructor(init?: Partial<PatientCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<PatientValidationResponse>) { (Object as any).assign(this, init); }
}

export class PostHasPermissionsResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public permissions?: { [index: string]: boolean; };

    public constructor(init?: Partial<PostHasPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class GetMetadataResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public metadata?: ITrialFormMetadata;

    public constructor(init?: Partial<GetMetadataResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataSingleResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: ISourceData;

    public constructor(init?: Partial<SourceDataSingleResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataNoteCollectionResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: ISourceDataNote[];

    public constructor(init?: Partial<SourceDataNoteCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataSummaryCollectionResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: ISourceDataSummary[];

    public constructor(init?: Partial<SourceDataSummaryCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataVoidResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SourceDataVoidResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataConfigurationSummaryCollectionResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: ISourceDataConfigurationSummary[];

    public constructor(init?: Partial<SourceDataConfigurationSummaryCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataConfigurationSingleResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: ISourceDataConfiguration;

    public constructor(init?: Partial<SourceDataConfigurationSingleResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitSummaryCollectionResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: IMonitoringVisitSummary[];

    public constructor(init?: Partial<MonitoringVisitSummaryCollectionResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitSingleResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: IMonitoringVisit;

    public constructor(init?: Partial<MonitoringVisitSingleResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitValidationResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public result?: IValidationResult;

    public constructor(init?: Partial<MonitoringVisitValidationResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitVoidResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<MonitoringVisitVoidResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitSettingsSingleResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: IMonitoringVisitSettings;

    public constructor(init?: Partial<MonitoringVisitSettingsSingleResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitSettingsValidationResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public result?: IValidationResult;

    public constructor(init?: Partial<MonitoringVisitSettingsValidationResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitSettingsInstitutionSingleResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: IMonitoringVisitSettingsInstitution;

    public constructor(init?: Partial<MonitoringVisitSettingsInstitutionSingleResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitSettingsInstitutionCollectionResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: IMonitoringVisitSettingsInstitution[];

    public constructor(init?: Partial<MonitoringVisitSettingsInstitutionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitSettingsInstitutionValidationResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public result?: IValidationResult;

    public constructor(init?: Partial<MonitoringVisitSettingsInstitutionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved trial. */
    // @DataMember(Order=2)
    public data?: Trial;

    public constructor(init?: Partial<TrialSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved trials. */
    // @DataMember(Order=2)
    public data?: Trial[];

    public constructor(init?: Partial<TrialCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<TrialValidationResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataFindingCollectionResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: ISourceDataFinding[];

    public constructor(init?: Partial<SourceDataFindingCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataFindingSingleResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public data?: ISourceDataFinding;

    public constructor(init?: Partial<SourceDataFindingSingleResponse>) { (Object as any).assign(this, init); }
}

export class SourceDataFindingValidationResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public result?: IValidationResult;

    public constructor(init?: Partial<SourceDataFindingValidationResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

// @Route("/hello")
// @Route("/hello/{Name}")
export class Hello implements IReturn<HelloResponse>
{
    [immerable] = true;
    public name?: string;

    public constructor(init?: Partial<Hello>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Hello'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HelloResponse(); }
}

/** @description Sign In */
// @Route("/auth", "OPTIONS,GET,POST,DELETE")
// @Route("/auth/{provider}", "OPTIONS,GET,POST,DELETE")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable] = true;
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider?: string;

    // @DataMember(Order=2)
    public state?: string;

    // @DataMember(Order=3)
    public oauth_token?: string;

    // @DataMember(Order=4)
    public oauth_verifier?: string;

    // @DataMember(Order=5)
    public userName?: string;

    // @DataMember(Order=6)
    public password?: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView?: string;

    // @DataMember(Order=10)
    public nonce?: string;

    // @DataMember(Order=11)
    public uri?: string;

    // @DataMember(Order=12)
    public response?: string;

    // @DataMember(Order=13)
    public qop?: string;

    // @DataMember(Order=14)
    public nc?: string;

    // @DataMember(Order=15)
    public cnonce?: string;

    // @DataMember(Order=17)
    public accessToken?: string;

    // @DataMember(Order=18)
    public accessTokenSecret?: string;

    // @DataMember(Order=19)
    public scope?: string;

    // @DataMember(Order=20)
    public returnUrl?: string;

    // @DataMember(Order=21)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userName?: string;

    // @DataMember(Order=2)
    public permissions?: string[];

    // @DataMember(Order=3)
    public roles?: string[];

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userName?: string;

    // @DataMember(Order=2)
    public permissions?: string[];

    // @DataMember(Order=3)
    public roles?: string[];

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    [immerable] = true;
    // @DataMember(Order=1)
    public environment?: string;

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public environment?: string;

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

// @Route("/participant-data/file-upload", "POST")
export class PostUploadFile implements IReturn<UploadResponse>, IPost
{
    [immerable] = true;

    public constructor(init?: Partial<PostUploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/participant-data/file-upload/info/{Guid}", "GET")
export class GetUploadInfo implements IReturn<UploadResponse>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetUploadInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/participant-data/file-upload/{Guid}", "GET")
export class GetUpload implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/participant-data/file-upload/download/{Guid}", "GET")
export class DownloadUpload implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<DownloadUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/participant-data/file-upload/{Guid}", "DELETE")
export class DeleteUpload implements IReturn<UploadResponse>, IDelete
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<DeleteUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUpload'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/participant-data/user/single/user", "GET")
// @Api(Description="User")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=500)
// @DataContract
export class UserGetSingle implements IReturn<UserSingleResponse>, IUserGetSingle
{
    [immerable] = true;
    /** @description The metadata of the request. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    public constructor(init?: Partial<UserGetSingle>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserGetSingle'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserSingleResponse(); }
}

// @Route("/participant-data/lookup/collection/form-definition/{FormDefinitionId}", "GET")
// @Api(Description="Lookup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=500)
// @DataContract
export class LookupGetCollectionByFormDefinitionId implements IReturn<LookupCollectionResponse>, ILookupGetCollectionByFormDefinitionId
{
    [immerable] = true;
    /** @description The ID of the Form Definition associated with the lookup to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId?: number;

    public constructor(init?: Partial<LookupGetCollectionByFormDefinitionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupGetCollectionByFormDefinitionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LookupCollectionResponse(); }
}

// @Route("/participant-data/form-names", "GET")
export class GetFormMetadata implements IReturn<GetFormMetadataResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetFormMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormMetadataResponse(); }
}

// @Route("/participant-data/form-type/single/id/{Id}", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetSingleById implements IReturn<FormTypeSingleResponse>, IConfigurationGetSingleById
{
    [immerable] = true;
    /** @description The ID of the form type to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormTypeGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeSingleResponse(); }
}

// @Route("/participant-data/form-type/collection", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetCollection implements IReturn<FormTypeCollectionResponse>, IConfigurationGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<FormTypeGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeCollectionResponse(); }
}

// @Route("/participant-data/form-type/single/code/{Code}", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetSingleByCode implements IReturn<FormTypeSingleResponse>, IConfigurationGetSingleByCode
{
    [immerable] = true;
    /** @description The ID of the form type to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<FormTypeGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeSingleResponse(); }
}

// @Route("/participant-data/form-definition/single/id/{Id}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleById implements IReturn<FormDefinitionSingleResponse>, IConfigurationGetSingleById
{
    [immerable] = true;
    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/participant-data/form-definition/collection", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetCollection implements IReturn<FormDefinitionCollectionResponse>, IConfigurationGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<FormDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionCollectionResponse(); }
}

// @Route("/participant-data/form-definition/single/code/{Code}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleByCode implements IReturn<FormDefinitionSingleResponse>, IConfigurationGetSingleByCode
{
    [immerable] = true;
    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<FormDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/participant-data/file/view/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/participant-data/file/download/{Id}", "GET")
export class DownloadFile implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<DownloadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/participant-data/master-group/single/id/{Id}", "GET")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleById implements IReturn<MasterGroupSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MasterGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/participant-data/master-group/collection", "GET")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetCollection implements IReturn<MasterGroupCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<MasterGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupCollectionResponse(); }
}

// @Route("/participant-data/master-group/create", "POST")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupPostCreate implements IReturn<MasterGroupSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the master group. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the master group. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationMasterGroup;

    public constructor(init?: Partial<MasterGroupPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/participant-data/master-group/save", "POST")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupPostSave implements IReturn<MasterGroupSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the master group. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The master group to save. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationMasterGroup;

    public constructor(init?: Partial<MasterGroupPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/participant-data/master-group/validate", "POST")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupValidationResponse)", StatusCode=500)
// @DataContract
export class MasterGroupPostValidate implements IReturn<MasterGroupValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the master group. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The master group to validate. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationMasterGroup;

    public constructor(init?: Partial<MasterGroupPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MasterGroupValidationResponse(); }
}

// @Route("/participant-data/master-group/collection/by-trial-id/{TrialId}", "GET")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetCollectionByTrialId implements IReturn<MasterGroupCollectionResponse>, IDataWithTrialGetCollectionByTrialId
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The ID of the trial associated with the master group to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<MasterGroupGetCollectionByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetCollectionByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupCollectionResponse(); }
}

// @Route("/participant-data/master-group/collection/by-trial-code/{TrialCode}", "GET")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetCollectionByTrialCode implements IReturn<MasterGroupCollectionResponse>, IDataWithTrialGetCollectionByTrialCode
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The code of the trial associated with the master group to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    public constructor(init?: Partial<MasterGroupGetCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupCollectionResponse(); }
}

// @Route("/participant-data/master-group/single/by-id-and-trial-id/{TrialId}/{Id}", "GET")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleByIdAndTrialId implements IReturn<MasterGroupSingleResponse>, IDataWithTrialGetSingleByIdAndTrialId
{
    [immerable] = true;
    /** @description The ID of the trial associated with the master group to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MasterGroupGetSingleByIdAndTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleByIdAndTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/participant-data/master-group/single/by-code-and-trial-code/{TrialCode}/{Code}", "GET")
// @Api(Description="Master Group - SourceDataVerificationMasterGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleByCodeAndTrialCode implements IReturn<MasterGroupSingleResponse>, IDataWithTrialGetSingleByCodeAndTrialCode
{
    [immerable] = true;
    /** @description The code of the trial associated with the master group to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    /** @description The code of the master group to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<MasterGroupGetSingleByCodeAndTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleByCodeAndTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/participant-data/coordinating-group/single/id/{Id}", "GET")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupGetSingleById implements IReturn<CoordinatingGroupSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the coordinating group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CoordinatingGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CoordinatingGroupSingleResponse(); }
}

// @Route("/participant-data/coordinating-group/collection", "GET")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupGetCollection implements IReturn<CoordinatingGroupCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<CoordinatingGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CoordinatingGroupCollectionResponse(); }
}

// @Route("/participant-data/coordinating-group/create", "POST")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupPostCreate implements IReturn<CoordinatingGroupSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the coordinating group. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the coordinating group. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCoordinatingGroup;

    public constructor(init?: Partial<CoordinatingGroupPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CoordinatingGroupSingleResponse(); }
}

// @Route("/participant-data/coordinating-group/save", "POST")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupPostSave implements IReturn<CoordinatingGroupSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the coordinating group. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The coordinating group to save. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCoordinatingGroup;

    public constructor(init?: Partial<CoordinatingGroupPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CoordinatingGroupSingleResponse(); }
}

// @Route("/participant-data/coordinating-group/validate", "POST")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupValidationResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupPostValidate implements IReturn<CoordinatingGroupValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the coordinating group. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The coordinating group to validate. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCoordinatingGroup;

    public constructor(init?: Partial<CoordinatingGroupPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CoordinatingGroupValidationResponse(); }
}

// @Route("/participant-data/coordinating-group/collection/by-trial-id/{TrialId}", "GET")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupGetCollectionByTrialId implements IReturn<CoordinatingGroupCollectionResponse>, IDataWithTrialGetCollectionByTrialId
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The ID of the trial associated with the coordinating group to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<CoordinatingGroupGetCollectionByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupGetCollectionByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CoordinatingGroupCollectionResponse(); }
}

// @Route("/participant-data/coordinating-group/collection/by-trial-code/{TrialCode}", "GET")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupGetCollectionByTrialCode implements IReturn<CoordinatingGroupCollectionResponse>, IDataWithTrialGetCollectionByTrialCode
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The code of the trial associated with the coordinating group to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    public constructor(init?: Partial<CoordinatingGroupGetCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupGetCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CoordinatingGroupCollectionResponse(); }
}

// @Route("/participant-data/coordinating-group/single/by-id-and-trial-id/{TrialId}/{Id}", "GET")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupGetSingleByIdAndTrialId implements IReturn<CoordinatingGroupSingleResponse>, IDataWithTrialGetSingleByIdAndTrialId
{
    [immerable] = true;
    /** @description The ID of the trial associated with the coordinating group to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    /** @description The ID of the coordinating group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CoordinatingGroupGetSingleByIdAndTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupGetSingleByIdAndTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CoordinatingGroupSingleResponse(); }
}

// @Route("/participant-data/coordinating-group/single/by-code-and-trial-code/{TrialCode}/{Code}", "GET")
// @Api(Description="Coordinating Group - SourceDataVerificationCoordinatingGroup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.CoordinatingGroup.CoordinatingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CoordinatingGroupGetSingleByCodeAndTrialCode implements IReturn<CoordinatingGroupSingleResponse>, IDataWithTrialGetSingleByCodeAndTrialCode
{
    [immerable] = true;
    /** @description The code of the trial associated with the coordinating group to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    /** @description The code of the coordinating group to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<CoordinatingGroupGetSingleByCodeAndTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatingGroupGetSingleByCodeAndTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CoordinatingGroupSingleResponse(); }
}

// @Route("/participant-data/country/single/id/{Id}", "GET")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleById implements IReturn<CountrySingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CountryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/participant-data/country/collection", "GET")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollection implements IReturn<CountryCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<CountryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/participant-data/country/create", "POST")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryPostCreate implements IReturn<CountrySingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the country. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the country. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCountry;

    public constructor(init?: Partial<CountryPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/participant-data/country/save", "POST")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryPostSave implements IReturn<CountrySingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the country. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The country to save. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCountry;

    public constructor(init?: Partial<CountryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/participant-data/country/validate", "POST")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Country.CountryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountryValidationResponse)", StatusCode=500)
// @DataContract
export class CountryPostValidate implements IReturn<CountryValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the country. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The country to validate. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationCountry;

    public constructor(init?: Partial<CountryPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CountryValidationResponse(); }
}

// @Route("/participant-data/country/collection/by-trial-id/{TrialId}", "GET")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByTrialId implements IReturn<CountryCollectionResponse>, IDataWithTrialGetCollectionByTrialId
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The ID of the trial associated with the country to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<CountryGetCollectionByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/participant-data/country/collection/by-trial-code/{TrialCode}", "GET")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByTrialCode implements IReturn<CountryCollectionResponse>, IDataWithTrialGetCollectionByTrialCode
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The code of the trial associated with the country to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    public constructor(init?: Partial<CountryGetCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/participant-data/country/single/by-id-and-trial-id/{TrialId}/{Id}", "GET")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleByIdAndTrialId implements IReturn<CountrySingleResponse>, IDataWithTrialGetSingleByIdAndTrialId
{
    [immerable] = true;
    /** @description The ID of the trial associated with the country to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CountryGetSingleByIdAndTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleByIdAndTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/participant-data/country/single/by-code-and-trial-code/{TrialCode}/{Code}", "GET")
// @Api(Description="Country - SourceDataVerificationCountry")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleByCodeAndTrialCode implements IReturn<CountrySingleResponse>, IDataWithTrialGetSingleByCodeAndTrialCode
{
    [immerable] = true;
    /** @description The code of the trial associated with the country to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    /** @description The code of the country to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<CountryGetSingleByCodeAndTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleByCodeAndTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/participant-data/institution/single/id/{Id}", "GET")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleById implements IReturn<InstitutionSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<InstitutionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/participant-data/institution/collection", "GET")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollection implements IReturn<InstitutionCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<InstitutionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/participant-data/institution/create", "POST")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionPostCreate implements IReturn<InstitutionSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the institution. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the institution. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationInstitution;

    public constructor(init?: Partial<InstitutionPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/participant-data/institution/save", "POST")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionPostSave implements IReturn<InstitutionSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the institution. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The institution to save. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationInstitution;

    public constructor(init?: Partial<InstitutionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/participant-data/institution/validate", "POST")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Institution.InstitutionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionValidationResponse)", StatusCode=500)
// @DataContract
export class InstitutionPostValidate implements IReturn<InstitutionValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the institution. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The institution to validate. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationInstitution;

    public constructor(init?: Partial<InstitutionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InstitutionValidationResponse(); }
}

// @Route("/participant-data/institution/collection/by-trial-id/{TrialId}", "GET")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByTrialId implements IReturn<InstitutionCollectionResponse>, IDataWithTrialGetCollectionByTrialId
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The ID of the trial associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/participant-data/institution/collection/by-trial-code/{TrialCode}", "GET")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByTrialCode implements IReturn<InstitutionCollectionResponse>, IDataWithTrialGetCollectionByTrialCode
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The code of the trial associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    public constructor(init?: Partial<InstitutionGetCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/participant-data/institution/single/by-id-and-trial-id/{TrialId}/{Id}", "GET")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleByIdAndTrialId implements IReturn<InstitutionSingleResponse>, IDataWithTrialGetSingleByIdAndTrialId
{
    [immerable] = true;
    /** @description The ID of the trial associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<InstitutionGetSingleByIdAndTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleByIdAndTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/participant-data/institution/single/by-code-and-trial-code/{TrialCode}/{Code}", "GET")
// @Api(Description="Institution - SourceDataVerificationInstitution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleByCodeAndTrialCode implements IReturn<InstitutionSingleResponse>, IDataWithTrialGetSingleByCodeAndTrialCode
{
    [immerable] = true;
    /** @description The code of the trial associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    /** @description The code of the institution to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<InstitutionGetSingleByCodeAndTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleByCodeAndTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/participant-data/patient/single/id/{Id}", "GET")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleById implements IReturn<PatientSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/participant-data/patient/collection", "GET")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollection implements IReturn<PatientCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<PatientGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/participant-data/patient/create", "POST")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostCreate implements IReturn<PatientSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the patient. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the patient. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationPatient;

    public constructor(init?: Partial<PatientPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/participant-data/patient/save", "POST")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSave implements IReturn<PatientSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the patient. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The patient to save. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationPatient;

    public constructor(init?: Partial<PatientPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/participant-data/patient/validate", "POST")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientPostValidate implements IReturn<PatientValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the patient. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The patient to validate. */
    // @DataMember(Order=2)
    public data?: SourceDataVerificationPatient;

    public constructor(init?: Partial<PatientPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/participant-data/patient/collection/by-trial-id/{TrialId}", "GET")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByTrialId implements IReturn<PatientCollectionResponse>, IDataWithTrialGetCollectionByTrialId
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The ID of the trial associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<PatientGetCollectionByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/participant-data/patient/collection/by-trial-code/{TrialCode}", "GET")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByTrialCode implements IReturn<PatientCollectionResponse>, IDataWithTrialGetCollectionByTrialCode
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    /** @description The code of the trial associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public trialCode?: string;

    public constructor(init?: Partial<PatientGetCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/participant-data/patient/single/by-id-and-trial-id/{TrialId}/{Id}", "GET")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleByIdAndTrialId implements IReturn<PatientSingleResponse>, IDataWithTrialGetSingleByIdAndTrialId
{
    [immerable] = true;
    /** @description The ID of the trial associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public trialId?: number;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientGetSingleByIdAndTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleByIdAndTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/participant-data/patient/single/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient - SourceDataVerificationPatient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Trials.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleByStudyNumber implements IReturn<PatientSingleResponse>, IPatientGetSingleByStudyNumber
{
    [immerable] = true;
    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber?: string;

    public constructor(init?: Partial<PatientGetSingleByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/participant-data/open-clinica/document", "GET")
export class GetOpenClinicaDocument implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public fileName?: string;

    public constructor(init?: Partial<GetOpenClinicaDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOpenClinicaDocument'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/participant-data/permissions", "POST")
export class PostHasPermissions implements IReturn<PostHasPermissionsResponse>, IPost
{
    [immerable] = true;
    public context?: SourceDataVerificationRequestContext;
    public permissions?: SourceDataVerificationPermission[];

    public constructor(init?: Partial<PostHasPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasPermissions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostHasPermissionsResponse(); }
}

export class GetMetadataByTrialId implements IReturn<GetMetadataResponse>, IGet
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetMetadataByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMetadataByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMetadataResponse(); }
}

export class GetMetadataByTrialCode implements IReturn<GetMetadataResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;

    public constructor(init?: Partial<GetMetadataByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMetadataByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMetadataResponse(); }
}

export class GetSourceDataById implements IReturn<SourceDataSingleResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetSourceDataById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataSingleResponse(); }
}

export class GetSourceDataNoteCollectionByTrialCode implements IReturn<SourceDataNoteCollectionResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;

    public constructor(init?: Partial<GetSourceDataNoteCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataNoteCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataNoteCollectionResponse(); }
}

export class GetSourceDataNoteCollectionByPatientStudyNumber implements IReturn<SourceDataNoteCollectionResponse>, IGet
{
    [immerable] = true;
    public patientStudyNumber?: string;

    public constructor(init?: Partial<GetSourceDataNoteCollectionByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataNoteCollectionByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataNoteCollectionResponse(); }
}

export class GetSourceDataSummaryCollectionByMonitoringVisitId implements IReturn<SourceDataSummaryCollectionResponse>, IGet
{
    [immerable] = true;
    public monitoringVisitId?: number;

    public constructor(init?: Partial<GetSourceDataSummaryCollectionByMonitoringVisitId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataSummaryCollectionByMonitoringVisitId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataSummaryCollectionResponse(); }
}

export class GetSourceDataSummaryCollectionByPatientId implements IReturn<SourceDataSummaryCollectionResponse>, IGet
{
    [immerable] = true;
    public patientId?: number;

    public constructor(init?: Partial<GetSourceDataSummaryCollectionByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataSummaryCollectionByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataSummaryCollectionResponse(); }
}

export class GetSourceDataSummaryCollectionByPatientStudyNumber implements IReturn<SourceDataSummaryCollectionResponse>, IGet
{
    [immerable] = true;
    public patientStudyNumber?: string;

    public constructor(init?: Partial<GetSourceDataSummaryCollectionByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataSummaryCollectionByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataSummaryCollectionResponse(); }
}

export class PostUpdateMonitoringVisitData implements IReturn<SourceDataSingleResponse>, IPost
{
    [immerable] = true;
    public sourceDataId?: number;
    public sourceDataConfigurationId?: number;

    public constructor(init?: Partial<PostUpdateMonitoringVisitData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUpdateMonitoringVisitData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataSingleResponse(); }
}

export class PostCreateSourceDataPreviewByTrialCodeAndPatientStudyNumber implements IReturn<SourceDataSingleResponse>, IPost
{
    [immerable] = true;
    public trialCode?: string;
    public patientStudyNumber?: string;
    public configuration?: ISourceDataConfiguration;

    public constructor(init?: Partial<PostCreateSourceDataPreviewByTrialCodeAndPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateSourceDataPreviewByTrialCodeAndPatientStudyNumber'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataSingleResponse(); }
}

export class PostCreateSourceDataPreviewByTrialIdAndPatientId implements IReturn<SourceDataSingleResponse>, IPost
{
    [immerable] = true;
    public trialId?: number;
    public patientId?: number;
    public configuration?: ISourceDataConfiguration;

    public constructor(init?: Partial<PostCreateSourceDataPreviewByTrialIdAndPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateSourceDataPreviewByTrialIdAndPatientId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataSingleResponse(); }
}

export class PostCreateSourceDataByTrialCodeAndPatientStudyNumber implements IReturn<SourceDataSingleResponse>, IPost
{
    [immerable] = true;
    public trialCode?: string;
    public patientStudyNumber?: string;
    public configurationId?: number;

    public constructor(init?: Partial<PostCreateSourceDataByTrialCodeAndPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateSourceDataByTrialCodeAndPatientStudyNumber'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataSingleResponse(); }
}

export class PostCreateSourceDataByTrialIdAndPatientId implements IReturn<SourceDataSingleResponse>, IPost
{
    [immerable] = true;
    public trialId?: number;
    public patientId?: number;
    public configurationId?: number;

    public constructor(init?: Partial<PostCreateSourceDataByTrialIdAndPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateSourceDataByTrialIdAndPatientId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataSingleResponse(); }
}

export class PostVerifySourceDataField implements IReturn<SourceDataVoidResponse>, IPost
{
    [immerable] = true;
    public sourceDataId?: number;
    public monitoringVisitId?: number;
    public sourceDataFieldId?: number;
    public verified?: boolean;

    public constructor(init?: Partial<PostVerifySourceDataField>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostVerifySourceDataField'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataVoidResponse(); }
}

export class PostReviewSourceDataField implements IReturn<SourceDataVoidResponse>, IPost
{
    [immerable] = true;
    public sourceDataId?: number;
    public monitoringVisitId?: number;
    public sourceDataFieldId?: number;
    public reviewed?: boolean;

    public constructor(init?: Partial<PostReviewSourceDataField>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostReviewSourceDataField'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataVoidResponse(); }
}

export class PostSaveSourceData implements IReturn<SourceDataSingleResponse>, IPost
{
    [immerable] = true;
    public data?: ISourceData;

    public constructor(init?: Partial<PostSaveSourceData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSaveSourceData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataSingleResponse(); }
}

export class PostUpdateSourceDataStatus implements IReturn<SourceDataVoidResponse>, IPost
{
    [immerable] = true;
    public sourceDataId?: number;
    public monitoringVisitId?: number;
    public status?: MonitoringVisitStatus;

    public constructor(init?: Partial<PostUpdateSourceDataStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUpdateSourceDataStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataVoidResponse(); }
}

export class GetSourceDataConfigurationSummaryCollectionByTrialId implements IReturn<SourceDataConfigurationSummaryCollectionResponse>, IGet
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetSourceDataConfigurationSummaryCollectionByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataConfigurationSummaryCollectionByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataConfigurationSummaryCollectionResponse(); }
}

export class GetSourceDataConfigurationSummaryCollectionByTrialCode implements IReturn<SourceDataConfigurationSummaryCollectionResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;

    public constructor(init?: Partial<GetSourceDataConfigurationSummaryCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataConfigurationSummaryCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataConfigurationSummaryCollectionResponse(); }
}

export class GetSourceDataTrialConfigurationByTrialId implements IReturn<SourceDataConfigurationSingleResponse>, IGet
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetSourceDataTrialConfigurationByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataTrialConfigurationByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataConfigurationSingleResponse(); }
}

export class GetSourceDataTrialConfigurationByTrialCode implements IReturn<SourceDataConfigurationSingleResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;

    public constructor(init?: Partial<GetSourceDataTrialConfigurationByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataTrialConfigurationByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataConfigurationSingleResponse(); }
}

export class PostCreateSourceDataConfigurationByTrialId implements IReturn<SourceDataConfigurationSingleResponse>, IPost
{
    [immerable] = true;
    public trialId?: number;
    public copyId?: number;

    public constructor(init?: Partial<PostCreateSourceDataConfigurationByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateSourceDataConfigurationByTrialId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataConfigurationSingleResponse(); }
}

export class PostCreateSourceDataConfigurationByTrialCode implements IReturn<SourceDataConfigurationSingleResponse>, IPost
{
    [immerable] = true;
    public trialCode?: string;
    public copyId?: number;

    public constructor(init?: Partial<PostCreateSourceDataConfigurationByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateSourceDataConfigurationByTrialCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataConfigurationSingleResponse(); }
}

export class GetSourceDataConfigurationById implements IReturn<SourceDataConfigurationSingleResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetSourceDataConfigurationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataConfigurationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataConfigurationSingleResponse(); }
}

export class PostSaveSourceDataConfiguration implements IReturn<SourceDataConfigurationSingleResponse>, IPost
{
    [immerable] = true;
    public data?: ISourceDataConfiguration;

    public constructor(init?: Partial<PostSaveSourceDataConfiguration>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSaveSourceDataConfiguration'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataConfigurationSingleResponse(); }
}

export class GetMonitoringVisitSummaryCollectionByTrialId implements IReturn<MonitoringVisitSummaryCollectionResponse>, IGet
{
    [immerable] = true;
    public trialId?: number;

    public constructor(init?: Partial<GetMonitoringVisitSummaryCollectionByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringVisitSummaryCollectionByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MonitoringVisitSummaryCollectionResponse(); }
}

export class GetMonitoringVisitSummaryCollectionByTrialCode implements IReturn<MonitoringVisitSummaryCollectionResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;

    public constructor(init?: Partial<GetMonitoringVisitSummaryCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringVisitSummaryCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MonitoringVisitSummaryCollectionResponse(); }
}

export class GetMonitoringVisitById implements IReturn<MonitoringVisitSingleResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetMonitoringVisitById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringVisitById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MonitoringVisitSingleResponse(); }
}

export class PostValidateMonitoringVisit implements IReturn<MonitoringVisitValidationResponse>, IPost
{
    [immerable] = true;
    public data?: IMonitoringVisit;

    public constructor(init?: Partial<PostValidateMonitoringVisit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostValidateMonitoringVisit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitValidationResponse(); }
}

export class PostCreateMonitoringVisit implements IReturn<MonitoringVisitSingleResponse>, IPost
{
    [immerable] = true;
    public data?: IMonitoringVisit;

    public constructor(init?: Partial<PostCreateMonitoringVisit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateMonitoringVisit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitSingleResponse(); }
}

export class PostSaveMonitoringVisit implements IReturn<MonitoringVisitSingleResponse>, IPost
{
    [immerable] = true;
    public data?: IMonitoringVisit;

    public constructor(init?: Partial<PostSaveMonitoringVisit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSaveMonitoringVisit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitSingleResponse(); }
}

export class PostUpdateMonitoringVisit implements IReturn<MonitoringVisitSingleResponse>, IPost
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<PostUpdateMonitoringVisit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUpdateMonitoringVisit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitSingleResponse(); }
}

export class PostUpdateMonitoringVisitStatus implements IReturn<MonitoringVisitVoidResponse>, IPost
{
    [immerable] = true;
    public monitoringVisitId?: number;
    public status?: MonitoringVisitStatus;

    public constructor(init?: Partial<PostUpdateMonitoringVisitStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUpdateMonitoringVisitStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitVoidResponse(); }
}

export class GetMonitoringVisitSettingsByTrialCode implements IReturn<MonitoringVisitSettingsSingleResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;

    public constructor(init?: Partial<GetMonitoringVisitSettingsByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringVisitSettingsByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MonitoringVisitSettingsSingleResponse(); }
}

export class PostValidateMonitoringVisitSettings implements IReturn<MonitoringVisitSettingsValidationResponse>, IPost
{
    [immerable] = true;
    public data?: IMonitoringVisitSettings;

    public constructor(init?: Partial<PostValidateMonitoringVisitSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostValidateMonitoringVisitSettings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitSettingsValidationResponse(); }
}

export class PostSaveMonitoringVisitSettings implements IReturn<MonitoringVisitSettingsSingleResponse>, IPost
{
    [immerable] = true;
    public data?: IMonitoringVisitSettings;

    public constructor(init?: Partial<PostSaveMonitoringVisitSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSaveMonitoringVisitSettings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitSettingsSingleResponse(); }
}

export class GetMonitoringVisitSettingsInstitutionByTrialAndInstitutionCode implements IReturn<MonitoringVisitSettingsInstitutionSingleResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;
    public institutionCode?: string;

    public constructor(init?: Partial<GetMonitoringVisitSettingsInstitutionByTrialAndInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringVisitSettingsInstitutionByTrialAndInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MonitoringVisitSettingsInstitutionSingleResponse(); }
}

export class GetMonitoringVisitSettingsInstitutionCollectionByTrialCode implements IReturn<MonitoringVisitSettingsInstitutionCollectionResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;

    public constructor(init?: Partial<GetMonitoringVisitSettingsInstitutionCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringVisitSettingsInstitutionCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MonitoringVisitSettingsInstitutionCollectionResponse(); }
}

export class PostValidateMonitoringVisitSettingsInstitution implements IReturn<MonitoringVisitSettingsInstitutionValidationResponse>, IPost
{
    [immerable] = true;
    public data?: IMonitoringVisitSettingsInstitution;

    public constructor(init?: Partial<PostValidateMonitoringVisitSettingsInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostValidateMonitoringVisitSettingsInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitSettingsInstitutionValidationResponse(); }
}

export class PostSaveMonitoringVisitSettingsInstitution implements IReturn<MonitoringVisitSettingsInstitutionSingleResponse>, IPost
{
    [immerable] = true;
    public data?: IMonitoringVisitSettingsInstitution;

    public constructor(init?: Partial<PostSaveMonitoringVisitSettingsInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSaveMonitoringVisitSettingsInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MonitoringVisitSettingsInstitutionSingleResponse(); }
}

// @Route("/participant-data/trial/single/id/{Id}", "GET")
// @Api(Description="Trial")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=500)
// @DataContract
export class TrialGetSingleById implements IReturn<TrialSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the trial to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TrialGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrialGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TrialSingleResponse(); }
}

// @Route("/participant-data/trial/collection", "GET")
// @Api(Description="Trial")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__SourceDataVerification.Trial.TrialCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__SourceDataVerification.Trial.TrialCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__SourceDataVerification.Trial.TrialCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__SourceDataVerification.Trial.TrialCollectionResponse)", StatusCode=500)
// @DataContract
export class TrialGetCollection implements IReturn<TrialCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<TrialGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrialGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TrialCollectionResponse(); }
}

// @Route("/participant-data/trial/create", "POST")
// @Api(Description="Trial")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=500)
// @DataContract
export class TrialPostCreate implements IReturn<TrialSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the trial. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the trial. */
    // @DataMember(Order=2)
    public data?: Trial;

    public constructor(init?: Partial<TrialPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrialPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TrialSingleResponse(); }
}

// @Route("/participant-data/trial/save", "POST")
// @Api(Description="Trial")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__SourceDataVerification.Trial.TrialSingleResponse)", StatusCode=500)
// @DataContract
export class TrialPostSave implements IReturn<TrialSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the trial. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The trial to save. */
    // @DataMember(Order=2)
    public data?: Trial;

    public constructor(init?: Partial<TrialPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrialPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TrialSingleResponse(); }
}

// @Route("/participant-data/trial/validate", "POST")
// @Api(Description="Trial")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__SourceDataVerification.Trial.TrialValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__SourceDataVerification.Trial.TrialValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__SourceDataVerification.Trial.TrialValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__SourceDataVerification.Trial.TrialValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__SourceDataVerification.Trial.TrialValidationResponse)", StatusCode=500)
// @DataContract
export class TrialPostValidate implements IReturn<TrialValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the trial. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The trial to validate. */
    // @DataMember(Order=2)
    public data?: Trial;

    public constructor(init?: Partial<TrialPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrialPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TrialValidationResponse(); }
}

export class GetSourceDataFindingCollectionByTrialCode implements IReturn<SourceDataFindingCollectionResponse>, IGet
{
    [immerable] = true;
    public trialCode?: string;

    public constructor(init?: Partial<GetSourceDataFindingCollectionByTrialCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataFindingCollectionByTrialCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataFindingCollectionResponse(); }
}

export class GetSourceDataFindingCollectionByPatientStudyNumber implements IReturn<SourceDataFindingCollectionResponse>, IGet
{
    [immerable] = true;
    public patientStudyNumber?: string;

    public constructor(init?: Partial<GetSourceDataFindingCollectionByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataFindingCollectionByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataFindingCollectionResponse(); }
}

export class GetSourceDataFindingCollectionByMonitoringVisitId implements IReturn<SourceDataFindingCollectionResponse>, IGet
{
    [immerable] = true;
    public monitoringVisitId?: number;

    public constructor(init?: Partial<GetSourceDataFindingCollectionByMonitoringVisitId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataFindingCollectionByMonitoringVisitId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataFindingCollectionResponse(); }
}

export class GetSourceDataFindingById implements IReturn<SourceDataFindingSingleResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetSourceDataFindingById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDataFindingById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDataFindingSingleResponse(); }
}

export class PostValidateSourceDataFinding implements IReturn<SourceDataFindingValidationResponse>, IPost
{
    [immerable] = true;
    public data?: ISourceDataFinding;

    public constructor(init?: Partial<PostValidateSourceDataFinding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostValidateSourceDataFinding'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataFindingValidationResponse(); }
}

export class PostSaveSourceDataFinding implements IReturn<SourceDataFindingSingleResponse>, IPost
{
    [immerable] = true;
    public data?: ISourceDataFinding;

    public constructor(init?: Partial<PostSaveSourceDataFinding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSaveSourceDataFinding'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDataFindingSingleResponse(); }
}

